






















































import './KisweButtonColorPicker.scss'
import { defineComponent, ref } from '@vue/composition-api'
import KisweButton from '../KisweButton'
import KiswePopover from '../../KiswePopover'
import { HexCode, isHexCode, KisweShape, KisweSize } from '@/modules/kisweui/types'
import { useShapes, useSizes } from '@/modules/kisweui/compositions'
import { KISWE_COLORS } from '@/modules/kisweui/data/colors'

export default defineComponent({
  name: 'KisweButtonColorPicker',
  components: {
    KisweButton,
    KiswePopover
  },
  props: {
    value: {
      type: String as () => HexCode|null,
      required: false,
      default: null
    },
    useNullValue: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    ...useSizes({ size: KisweSize.Small }).props,
    ...useShapes({ shape: KisweShape.Square }).props
  },
  emits: {
    input (_hexValue: HexCode|null) { return true }
  },
  setup () {
    const isToggled = ref(false)
    return { KISWE_COLORS, isToggled }
  },
  methods: {
    hasNoValue (color: HexCode|null): boolean {
      return color === null || color === '#FFFFFF00' || !isHexCode(color)
    },
    setColor (newVal: HexCode|null) {
      if (this.useNullValue && newVal === null) {
        this.$emit('input', null)
      } else if (newVal === null) {
        this.$emit('input', '#FFFFFF00')
      } else {
        this.$emit('input', `${ newVal }FF`)
      }
      this.isToggled = false
    },
    onClickOutside () {
      this.isToggled = false
    }
  }
})
